import { FeatureName, isFeatureAvailable } from '@/features.config'
import { useMemo } from 'react'
import { useViewport, Viewport } from './useViewport'

/**
 * Hook to check if a feature is available for the current viewport.
 *
 * @param feature - The feature identifier to check
 * @returns Object containing availability status and current viewport
 *
 * @example
 * const { isAvailable, viewport } = useFeatureAvailability(FEATURES.MY_COURSES)
 *
 * if (!isAvailable) {
 *   return <MobileNotSupported />
 * }
 * return <TrainingsPage />
 */
export const useFeatureAvailability = (
  feature: FeatureName,
): {
  isAvailable: boolean
  viewport: Viewport
} => {
  const viewport = useViewport()

  return useMemo(
    () => ({
      isAvailable: isFeatureAvailable(feature, viewport),
      viewport,
    }),
    [feature, viewport],
  )
}
